import { Facebook, Twitter, Instagram, Youtube, Music, Globe } from "lucide-react";
import logo from "@/assets/ekselencia-logo.webp";

export const FooterBrand = () => {
  return (
    <div className="lg:col-span-1">
      <img src={logo} alt="Ekselencia Logo" className="h-10 mb-4" />
      <p className="text-muted-foreground text-sm mb-4">
        Tu directorio deportivo y fitness definitivo. Conectando atletas, gimnasios y entusiastas del fitness en toda España.
      </p>
      
      {/* International Links */}
      <div className="flex flex-wrap gap-3 mb-4 text-sm">
        <a
          href="https://en.ekselencia.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-muted-foreground hover:text-primary transition-colors flex items-center gap-1"
        >
          🇬🇧 English
        </a>
        <a
          href="https://nl.ekselencia.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-muted-foreground hover:text-primary transition-colors flex items-center gap-1"
        >
          🇳🇱 Nederland
        </a>
      </div>
      
      {/* Social Links */}
      <div className="flex gap-4">
        <a 
          href="https://www.facebook.com/ekselencia" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-muted-foreground hover:text-primary transition-colors"
          aria-label="Facebook"
        >
          <Facebook className="w-5 h-5" />
        </a>
        <a 
          href="https://www.tiktok.com/@ekselencia" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-muted-foreground hover:text-primary transition-colors"
          aria-label="TikTok"
        >
          <Music className="w-5 h-5" />
        </a>
        <a 
          href="#" 
          className="text-muted-foreground hover:text-primary transition-colors"
          aria-label="Twitter"
        >
          <Twitter className="w-5 h-5" />
        </a>
        <a 
          href="#" 
          className="text-muted-foreground hover:text-primary transition-colors"
          aria-label="Instagram"
        >
          <Instagram className="w-5 h-5" />
        </a>
        <a 
          href="https://www.youtube.com/@ekselencia" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-muted-foreground hover:text-primary transition-colors"
          aria-label="YouTube"
        >
          <Youtube className="w-5 h-5" />
        </a>
      </div>
    </div>
  );
};
